import React from "react"

import WalmartLogo from "../../../icons/walmart-logo-icon.svg"
import WalmartMuseumLogo from "../../../icons/companies/the-walmart-museum.svg"
import { SocketWrapper } from '@/components/socket.tsx';
import styles from "./error.module.scss"

export const ErrorPage = () => {
    return <SocketWrapper>
        <div className={styles['error-page']}>
            <div className={styles['error-page__text']}>
                <span className={styles['error-page__title']}>
                    Sorry, this page does not exist
                </span>
                <span className={styles['error-page__description']}>Please check the admin panel</span>
            </div>
            <div className={styles['error-page__logos']}>
                <img  src={WalmartMuseumLogo} />
                <img src={WalmartLogo} />
            </div>
        </div>
    </SocketWrapper>
}
